import api from './client';

export const getSwitchboards = (projectId) => api.get('/switchboards', { params: { project: projectId } });
export const createSwitchboard = (data) => api.post('/switchboards', data);
export const updateSwitchboard = (id, data) => api.put(`/switchboards/${id}`, data);
export const deleteSwitchboard = (id) => api.delete(`/switchboards/${id}`);
